/**
 * iPlanet — Switch to iPhone for ₹9,999
 * Interactive logic: calculator, device cards, drag-scroll, reveal, lead form
 */

window.iPlanet = (function () {

  /* ═══════════════════════════════════════
     TRADE-IN DATABASE
  ═══════════════════════════════════════ */
  const DB = {
    OnePlus: [
      { m: 'OnePlus 13',            s: '256GB + 12GB', f: 38000, min: 35000 },
      { m: 'OnePlus 13s',           s: '512GB + 16GB', f: 33000, min: 30000 },
      { m: 'OnePlus 12',            s: '512GB + 16GB', f: 25000, min: 22000 },
      { m: 'OnePlus 13R',           s: '256GB + 12GB', f: 25000, min: 22000 },
      { m: 'OnePlus Nord 5',        s: '512GB + 12GB', f: 22000, min: 20000 },
      { m: 'OnePlus 12R',           s: '256GB + 16GB', f: 21000, min: 18000 },
      { m: 'OnePlus 11 5G',         s: '256GB + 16GB', f: 18000, min: 16000 },
      { m: 'OnePlus 11R Solar Red', s: '256GB + 18GB', f: 18000, min: 16000 },
      { m: 'OnePlus 11 R',          s: '256GB + 16GB', f: 16000, min: 13000 },
      { m: 'OnePlus 11R 5G',        s: '512GB + 18GB', f: 16000, min: 14000 },
      { m: 'OnePlus Nord 4',        s: '256GB + 8GB',  f: 14000, min: 12000 },
      { m: 'OnePlus Nord 4 5G',     s: '256GB + 8GB',  f: 14000, min: 12000 },
      { m: 'OnePlus Nord CE 5 5G',  s: '256GB + 12GB', f: 13000, min: 12000 },
      { m: 'OnePlus 10 Pro 5G',     s: '256GB + 12GB', f: 13000, min: 11000 },
      { m: 'OnePlus 10 Pro',        s: '256GB + 12GB', f: 13000, min: 11000 },
      { m: 'OnePlus 10T 5G',        s: '256GB + 16GB', f: 12000, min: 10000 },
      { m: 'OnePlus 9 Pro',         s: '256GB + 12GB', f: 10000, min: 9000  },
      { m: 'OnePlus 9 Pro 5G',      s: '256GB + 12GB', f: 10000, min: 9000  },
      { m: 'OnePlus 8 Pro',         s: '256GB + 12GB', f: 10000, min: 9000  },
    ]
  };

  const IPHONES = [
    { price: 53253, label: 'iPhone 15' },
    { price: 62805, label: 'iPhone 16' },
    { price: 81242, label: 'iPhone 17' },
  ];

  /* ═══════════════════════════════════════
     STATE
  ═══════════════════════════════════════ */
  let cond      = 'f';
  let iphoneIdx = 2;

  function fmt(n) {
    return '₹' + Math.round(n).toLocaleString('en-IN');
  }

  function onBrand() {
    const brand = document.getElementById('brandSel').value;
    const sel   = document.getElementById('modelSel');
    sel.innerHTML = '<option value="">Select Model</option>';
    if (brand && DB[brand]) {
      DB[brand].forEach((d, i) => {
        const o       = document.createElement('option');
        o.value       = i;
        o.textContent = d.m + ' (' + d.s + ')';
        sel.appendChild(o);
      });
    }
  }

  function setCond(type, btn) {
    cond = type;
    document.querySelectorAll('.cond-btn').forEach(b => b.classList.remove('on'));
    btn.classList.add('on');
  }

  function setPhone(idx, btn) {
    iphoneIdx = idx;
    document.querySelectorAll('.iph-btn').forEach(b => b.classList.remove('on'));
    btn.classList.add('on');
  }

  function calculate() {
    const brand = document.getElementById('brandSel').value;
    const mi    = document.getElementById('modelSel').value;
    if (!brand || mi === '') {
      flashRed(document.getElementById('modelSel'));
      return;
    }
    const dev    = DB[brand][+mi];
    const iphone = IPHONES[iphoneIdx];
    const trade  = cond === 'f' ? dev.f : dev.min;
    const net    = Math.max(iphone.price - trade, 0);
    const saved  = iphone.price - net;

    document.getElementById('rLabel').textContent      = iphone.label;
    document.getElementById('rSalePrice').textContent  = fmt(iphone.price);
    document.getElementById('rTrade').textContent      = '− ' + fmt(trade);
    document.getElementById('rSaved').textContent      = fmt(saved);
    document.getElementById('resEmpty').style.display  = 'none';
    document.getElementById('resBox').classList.add('show');
    countUp(document.getElementById('rNet'), net);
  }

  function countUp(el, target) {
    const t0 = performance.now();
    (function tick(now) {
      const p = Math.min((now - t0) / 700, 1);
      el.textContent = fmt(Math.round((1 - Math.pow(1 - p, 3)) * target));
      if (p < 1) requestAnimationFrame(tick);
      else el.textContent = fmt(target);
    })(t0);
  }

  function flashRed(el) {
    if (!el) return;
    el.style.borderColor = '#ff3b30';
    el.style.boxShadow   = '0 0 0 4px rgba(255,59,48,.15)';
    setTimeout(() => { el.style.borderColor = ''; el.style.boxShadow = ''; }, 1400);
  }

  /* ═══════════════════════════════════════
     DEVICE CARDS
  ═══════════════════════════════════════ */
  let dragging = false;

  function cardClick(card, brand, idx) {
    if (dragging) return;
    const brandSel = document.getElementById('brandSel');
    const modelSel = document.getElementById('modelSel');
    if (!brandSel || !modelSel) return;
    brandSel.value = brand;
    onBrand();
    requestAnimationFrame(() => { modelSel.value = idx; });
    document.querySelectorAll('.dev-card').forEach(c => c.style.outline = '');
    card.style.outline = '2px solid #0071e3';
    goTo('#calculator');
  }

  function filterCards(brand, btn) {
    document.querySelectorAll('.fil-btn').forEach(b => b.classList.remove('on'));
    btn.classList.add('on');
    document.querySelectorAll('.dev-card').forEach(c => {
      c.style.display = (brand === 'all' || c.dataset.brand === brand) ? 'flex' : 'none';
    });
    const track = document.getElementById('devTrack');
    const fadeL = document.getElementById('fadeL');
    if (track) track.scrollLeft = 0;
    if (fadeL) fadeL.style.opacity = '0';
  }

  /* ═══════════════════════════════════════
     DRAG-TO-SCROLL
  ═══════════════════════════════════════ */
  function initDrag() {
    const track = document.getElementById('devTrack');
    const fadeL = document.getElementById('fadeL');
    if (!track) return;
    let startX = 0, startScroll = 0;
    track.addEventListener('scroll', () => {
      if (fadeL) fadeL.style.opacity = track.scrollLeft > 20 ? '1' : '0';
    }, { passive: true });
    track.addEventListener('mousedown', e => {
      dragging = false; startX = e.pageX; startScroll = track.scrollLeft;
      track.style.cursor = 'grabbing';
      const onMove = e => {
        const dx = e.pageX - startX;
        if (Math.abs(dx) > 5) dragging = true;
        track.scrollLeft = startScroll - dx;
      };
      const onUp = () => {
        track.style.cursor = 'grab';
        window.removeEventListener('mousemove', onMove);
        window.removeEventListener('mouseup', onUp);
        setTimeout(() => { dragging = false; }, 60);
      };
      window.addEventListener('mousemove', onMove);
      window.addEventListener('mouseup', onUp);
    });
    document.querySelectorAll('.dev-card').forEach(card => {
      card.addEventListener('keydown', e => {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); card.click(); }
      });
    });
  }

  /* ═══════════════════════════════════════
     ENTRANCE + REVEAL
  ═══════════════════════════════════════ */
  function initEntrance() {
    const track = document.getElementById('devTrack');
    if (!track) return;
    const obs = new IntersectionObserver(entries => {
      if (!entries[0].isIntersecting) return;
      document.querySelectorAll('.dev-card').forEach((c, i) => {
        c.style.opacity    = '0';
        c.style.transform  = 'translateY(12px)';
        c.style.transition = `opacity .35s ease ${i * 0.025}s, transform .35s ease ${i * 0.025}s`;
        setTimeout(() => { c.style.opacity = '1'; c.style.transform = 'none'; }, i * 25);
      });
      obs.disconnect();
    }, { threshold: 0.05 });
    obs.observe(track);
  }

  function initReveal() {
    const obs = new IntersectionObserver(entries => {
      entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('in'); });
    }, { threshold: 0.1 });
    document.querySelectorAll('.reveal').forEach(el => obs.observe(el));
  }

  function goTo(selector) {
    const el = document.querySelector(selector);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initDrag();
    initEntrance();
    initReveal();
  });

  /* ═══════════════════════════════════════
     LEAD FORM — hidden iframe POST
     Works with Google Apps Script even when
     no-cors fetch returns 503.
  ═══════════════════════════════════════ */
  const LEADS_URL = 'https://script.google.com/macros/s/AKfycbxXRzM4b_ZQd8f2M4JTx58BrdKZ1Ztt4RGvdcc-lesBy9YG8MRjCbDITMZq1oy7LRuSgQ/exec';

  function submitLead() {
    const get = id => (document.getElementById(id) || {}).value || '';

    const required = ['fFirst', 'fLast', 'fPhone', 'fDevice', 'fCond'];
    for (const id of required) {
      const el = document.getElementById(id);
      if (!el || !el.value.trim()) { flashRed(el); el && el.focus(); return; }
    }

    const btn = document.getElementById('formBtn');
    btn.disabled    = true;
    btn.textContent = 'Sending…';

    const payload = {
      first_name:   get('fFirst'),
      last_name:    get('fLast'),
      phone:        '+91' + get('fPhone'),
      email:        get('fEmail'),
      device:       get('fDevice'),
      condition:    get('fCond'),
      iphone_model: get('fIphone'),
      timeline:     get('fTimeline'),
      store:        get('fStore'),
    };

    // Hidden iframe POST — follows Google's redirect chain reliably
    _iframePost(payload);

    // Show success immediately
    setTimeout(() => {
      document.getElementById('formSuccess').style.display = 'block';
      document.getElementById('formError').style.display   = 'none';
      document.querySelectorAll('#formWrap .field-label, #formWrap .fname-row, #formWrap .phone-row, #formWrap .finput').forEach(el => el.style.display = 'none');
      btn.style.display = 'none';
    }, 400);
  }

  function _iframePost(payload) {
    // Create a hidden iframe as the form target
    const ifr = document.createElement('iframe');
    ifr.name  = '_leadFrame_' + Date.now();
    ifr.style.cssText = 'position:absolute;width:1px;height:1px;opacity:0;pointer-events:none';
    document.body.appendChild(ifr);

    // Build and submit hidden form into the iframe
    const frm = document.createElement('form');
    frm.method  = 'POST';
    frm.action  = LEADS_URL;
    frm.target  = ifr.name;
    frm.style.display = 'none';

    Object.keys(payload).forEach(k => {
      const inp = document.createElement('input');
      inp.type  = 'hidden';
      inp.name  = k;
      inp.value = payload[k];
      frm.appendChild(inp);
    });

    document.body.appendChild(frm);
    frm.submit();

    // Cleanup after 10s
    setTimeout(() => {
      try { document.body.removeChild(frm); document.body.removeChild(ifr); } catch(e) {}
    }, 10000);
  }

  return { onBrand, setCond, setPhone, calculate, cardClick, filterCards, goTo, submitLead, LEADS_URL };

})();
